import { render, staticRenderFns } from "./quotation-part-add-or-update.vue?vue&type=template&id=01e9fd88&scoped=true"
import script from "./quotation-part-add-or-update.vue?vue&type=script&lang=js"
export * from "./quotation-part-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./quotation-part-add-or-update.vue?vue&type=style&index=0&id=01e9fd88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e9fd88",
  null
  
)

export default component.exports